import BaseRepository from '@/api/BaseRepository';

export default class ReportsRepository extends BaseRepository {
    public getOverviewStats(): Promise<any> {
        return this.axiosClient.get('/reports/overview');
    }

    public getTopLabels(year?: number, limit = 50): Promise<any> {
        const params = new URLSearchParams();
        if (year) params.append('year', String(year));
        params.append('limit', String(limit));
        return this.axiosClient.get(`/reports/labels/top?${params}`);
    }

    public getLabelsByYear(): Promise<any> {
        return this.axiosClient.get('/reports/labels/by-year');
    }

    public getLabelStats(): Promise<any> {
        return this.axiosClient.get('/reports/labels/stats');
    }

    public getActuatorStats(): Promise<any> {
        return this.axiosClient.get('/reports/actuator-stats');
    }

    public getActuatorTypes(): Promise<any> {
        return this.axiosClient.get('/reports/actuator-types');
    }

    public getActuatorTypeModels(type: string): Promise<any> {
        return this.axiosClient.get(`/reports/actuator-type-models?type=${encodeURIComponent(type)}`);
    }

    public getActuatorTypeModelStations(type: string, label: string): Promise<any> {
        const params = new URLSearchParams({ type, label });
        return this.axiosClient.get(`/reports/actuator-type-model-stations?${params}`);
    }

    public getActuatorTypesByMonth(): Promise<any> {
        return this.axiosClient.get('/reports/actuator-types/by-month');
    }

    public getProjectStats(): Promise<any> {
        return this.axiosClient.get('/reports/projects/stats');
    }

    /**
     * Aggregated sales funnel + sizing statistics for the Projects report.
     * See docs/reports-funnel-overview-api.md for the response contract.
     */
    public getProjectFunnelOverview(): Promise<any> {
        return this.axiosClient.get('/reports/projects/funnel-overview');
    }

    public getProjectsByCustomer(): Promise<any> {
        return this.axiosClient.get('/reports/projects/by-customer');
    }

    public getCustomerStats(): Promise<any> {
        return this.axiosClient.get('/reports/customers/stats');
    }

    public getTechnicalStats(): Promise<any> {
        return this.axiosClient.get('/reports/technical/stats');
    }
}
